import { useState } from "react";
import emailjs from "@emailjs/browser";
import { width } from "@fortawesome/free-solid-svg-icons/fa0";

export default function Contacts() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await emailjs.send(
        "service_f055kya",
        "template_7gbq9ap",
        {
          admin_email: "nkechukwu@nv.luxury",
          full_name: form.fullName,
          email: form.email,
          message: form.message,
        },
        "FeJD_kM1e0tvi4MfV"
      );

      alert("Message sent successfully!");

      setForm({
        fullName: "",
        email: "",
        message: "",
      });
    } catch (err) {
      console.error(err);
      alert("Failed to send message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        maxWidth: 520,
        padding: 24,
        margin: "auto",
        fontFamily: "Playfair Display, serif",
        
      }}
      className="contact-form"
    >
      <h2 style={{textAlign: "center", fontSize: "45px", fontWeight: "bold"}} className="appear">Contacts</h2>
      <p style={{textAlign: "center", marginBottom: "50px", fontFamily: "Inter, sans-serif", fontWeight: "400", fontSize: "18px", marginTop: "-30px"}} className="appear">Have questions? We'd love to hear from you!</p>

      <div  className="contact-form-group appear">
          
        <div>
          <label htmlFor="fullName">Full Name</label> <br/>

          <input
            name="fullName"
            placeholder="Full Name"
            value={form.fullName}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="email">Email</label> <br/>

          <input
            name="email"
            type="email"
            placeholder="spark@gmail.com"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>


        <div className="contact-textarea-div">
          <label htmlFor="message">Message</label> <br/>

          <textarea
            name="message"
            placeholder="Your Message"
            value={form.message}
            onChange={handleChange}
            required
            rows={5}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="contact-submit-button"
          style={{
            
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Sending..." : "Send Message"}
        </button>
      </div>
    </form>
  );
}


     

